import { HANDLE_DRAWER } from '../../types';
import { IDrawerState } from '../../types/drawer';
import { IAction } from '../../types/generics';

const initState: IDrawerState = {
  isOpen: true,
  loader: '',
};

export default function (state = initState, action: IAction) {
  switch (action.type) {
    case HANDLE_DRAWER: {
      return {
        ...state,
        loader: new Date(),
        isOpen: action.payload,
      };
    }

    default:
      return state;
  }
}
